module.exports = __webpack_public_path__ + "img/icon-logo.9687b3e3.png";